import * as React from 'react';

import { cn } from '@playbooks/ui/lib/utils';

import { type VariantProps, cva } from 'class-variance-authority';

const itemVariants = cva('min-w-0 gap-4 px-4 py-3', {
	variants: {
		layout: {
			default: 'flex-between min-h-14',
			start: 'flex-start min-h-14',
			stacked: 'flex-column items-stretch',
		},
	},
	defaultVariants: { layout: 'default' },
});

type ItemProps = React.ComponentProps<'li'> & VariantProps<typeof itemVariants>;

function Item({ className = '', layout, ...props }: ItemProps) {
	// Theme
	const rootClassName = cn(itemVariants({ layout }), className);

	// Render
	return <li className={rootClassName} {...props} />;
}

function ItemContent({ className = '', ...props }: React.ComponentProps<'div'>) {
	// Theme
	const rootClassName = cn('min-w-0 flex-1 space-y-0.5', className);

	// Render
	return <div className={rootClassName} {...props} />;
}

function ItemTitle({ className = '', ...props }: React.ComponentProps<'h3'>) {
	// Theme
	const rootClassName = cn('type-label', className);

	// Render
	return <h3 className={rootClassName} {...props} />;
}

function ItemDescription({ className = '', ...props }: React.ComponentProps<'p'>) {
	// Theme
	const rootClassName = cn('text-sm text-foreground-body', className);

	// Render
	return <p className={rootClassName} {...props} />;
}

function ItemActions({ className = '', ...props }: React.ComponentProps<'div'>) {
	// Theme
	const rootClassName = cn('flex-start shrink-0 gap-2', className);

	// Render
	return <div className={rootClassName} {...props} />;
}

export { Item, ItemActions, ItemContent, ItemDescription, ItemTitle };
export type { ItemProps };
